import {Alert} from "react-bootstrap";
import PropTypes from "prop-types";

const Validation = (props) => {


    let styles

    if (props.wiz.validation?.map(v => v.key).includes(props.field) && props.bordered) {
        styles = {
            border: '2px solid #f5c2c7',
            padding: '0.375rem 0.75rem'
        }
    } else {
        styles = {}
    }

    return <div id={props?.wiz?.pageKey + '.' + props.field}>
        <div style={styles}>{props?.children}</div>
        {props?.wiz?.validation?.filter(v => v.key === props.field)
            .map((v, idx) => {
                return <Alert key={idx} variant={v.type === 'error' ? 'danger' : "warning"} className="p-2 mt-1 text-center">
                    {v.msgs.map((msg, i) => {
                        const message = msg.length > 55 ? 'Błąd: Szczegóły w sekcji "PODSUMOWANIE"' : msg
                        return <div style={{textAlign: 'center'}} key={i}>{message}</div>
                    })?.[0]}
                </Alert>
            })

        }
    </div>
}

export default Validation

Validation.propTypes = {
    bordered: PropTypes.bool,
    wiz: PropTypes.object,
    field: PropTypes.string,
    children: PropTypes.any
};

